// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Travel } = initSchema(schema);

export {
  Travel
};